
import Vue from 'vue';
import {
  FavoriteCategory,
  TopColum,
  TrainingCategory,
  TrainingCategoryDefault,
} from '@/components/types';
import EventService from '../services/EventService';
import {getStatus} from '@/dummy/dummydata';
import moment from 'moment';
import {mapState} from 'vuex';
import {
  GetScopeFromKey,
  ConfSortByType, // TODO (ohtsuchi) 2025年以降 コードを削除
  ConfSortByValue, // TODO (ohtsuchi) 2025年以降 コードを削除
  ScopeKey,
} from '../store/index';
import Breadcrumbs from '../components/breadcrumbs.vue';
import type {User} from 'firebase/auth';
import {GroupRes} from '@/services/types';

const FAVORITE_CATEGORY_KEY = 'favorite';
const emptyFavoriteCategory: TrainingCategory = {
  key: FAVORITE_CATEGORY_KEY,
  name: '',
  order: -1,
};
const isFavoriteCategory = (tag: TrainingCategory) =>
  tag.key === FAVORITE_CATEGORY_KEY;
const existsFavoriteCategory = (tags: TrainingCategory[]) =>
  tags.some(isFavoriteCategory);

const trainingIDsCompare = (a: string, b: string): number => {
  let x = a.replace(/^F/, '');
  let z = b.replace(/^F/, '');
  x = x.replace('H', '999');
  z = z.replace('H', '999');
  const xi = parseInt(x, 10) || 0;
  const zi = parseInt(z, 10) || 0;
  return xi - zi;
};

type Colum = {
  done: boolean;
  conf: TopColum;
  title: string;
  month: string;
  id: string;
  isActive: boolean;
  safetyEducationIndex: number;
  tags: TrainingCategory[];
};

type ColumGroups = Array<Array<Colum>>;

type Item = {
  text: string;
  disabled: boolean;
  to: string;
};

type BranchOffice = GroupRes & {
  name: string;
  check: boolean;
  favoriteIDsCSV: string;
  msg: string;
};

type Data = {
  trainings: Array<Colum>;
  expired: Array<Colum>;
  notDeadline: Array<Colum>;
  doing: Array<Colum>;
  done: Array<Colum>;
  conf: TopColum | null;
  check: boolean;
  allTags: TrainingCategory[];
  filterTag: string;
  favoriteTag: TrainingCategory;
  existsFavoriteCategory: (tags: TrainingCategory[]) => boolean;
  branchOfficeList: BranchOffice[];
  allBranchOfficeCheck: boolean;
  isLoading: boolean;
  snackbar: boolean;
  snackbarMessage: string;
  snackbarColor: string;
  snackbarTimeout: number;
};

type Method = {
  jump(id: string): void;
  indexFormat(src: number): string;
  toggleFavorite(c: Colum): Promise<void>;
  toggleBranchOffice(bo: BranchOffice): void;
  copyFavorite(): Promise<void>;
  mountBranchOfficeList(token: string): Promise<void>;
  initBranchOfficeList(): void;
  isBranchOfficeSameFavoriteIDs(bo: BranchOffice): boolean;
  createBranchOfficeMsg(bo: BranchOffice): string;
};

type Computed = {
  columGroups: ColumGroups;
  canShowFilterTag: boolean;
  favoriteIDsCSV: string;
  isViewBranchOfficeList: boolean;
  isAnyBranchOfficeChecked: boolean;
  isAllBranchOfficeSameFavoriteIDs: boolean;
  isNoSubGroup: boolean;
  user: User | undefined;
  current: string;
  currentScope: ScopeKey;
  sameGroupBranchOfficeList: Array<GroupRes>;
  noSubGroupStartYear: number;
  sortBy: ConfSortByType;
};

type Props = {
  year: string;
  main: boolean;
};

export default Vue.extend<Data, Method, Computed, Props>({
  components: {
    Breadcrumbs,
  },
  props: {
    year: {
      type: String,
      default: '',
    },
    main: {
      type: Boolean,
      default: true,
    },
  },
  async mounted() {
    // await axios.get('http://localhost:8080/news/', {withCredentials: true});
    // await axios.get('http://localhost:8080/news/');
    const token = await this.user?.getIdToken();
    if (token) {
      await this.$store.dispatch('scope');
      try {
        const {data} = await EventService.getTrainings(
          token,
          this.year,
          this.main,
          GetScopeFromKey(this.currentScope)
        );
        data.sort((a, b) => {
          const ma = moment(a.deadline);
          const mb = moment(b.deadline);
          if (ma.isBefore(mb)) {
            return -1;
          }
          if (ma.isAfter(mb)) {
            return 1;
          }
          return 0;
        });

        // TODO (ohtsuchi) 2025年以降 コードを削除 --- ここから
        if ((this.sortBy as ConfSortByType) === ConfSortByValue.Changed) {
          const sortByIDChar = (a: {id: string}, b: {id: string}): number => {
            return a.id.localeCompare(b.id);
          };
          data.sort(sortByIDChar);
        }
        // TODO (ohtsuchi) 2025年以降 コードを削除 --- ここまで

        data.forEach(item => {
          const sts = getStatus(
            item.deadline,
            item.total,
            item.done,
            this.main
          );
          // console.log(item.detail, item.deadline, sts, item.total, item.done);

          const conf = TopColum(sts);
          if (!conf) {
            return;
          }

          if (!this.main) {
            // サーバー側で Training の tags と Category を inner join した結果をフロント側で重複排除
            this.allTags = [
              ...new Map(
                [...this.allTags, ...item.tags].map(tag => [tag.key, tag]) // key で 重複排除
              ).values(),
            ];
          }

          const colum = {
            done: sts == 'done',
            conf: conf,
            title: item.detail,
            month: item.detail,
            id: item.id,
            isActive: item.isActive,
            safetyEducationIndex: item.safetyEducationIndex,
            tags: item.tags,
          };
          if (colum.isActive) {
            this.trainings.push(colum);
            switch (sts) {
              case 'expired':
                this.expired.push(colum);
                break;
              case 'no-deadline':
                this.notDeadline.push(colum);
                break;
              case 'doing':
                this.doing.push(colum);
                break;
              case 'done':
                this.done.push(colum);
                break;
            }
          }
        });

        if (!this.main) {
          // 初期表示時点で favorite が含まれていなければサーバー側から取得
          if (!existsFavoriteCategory(this.allTags)) {
            const {data: fData} =
              await EventService.getFavoriteTrainingCategory(token);
            if (fData.trainingCategories.length > 0) {
              this.favoriteTag = fData.trainingCategories[0];
            }
          } else {
            this.favoriteTag = this.allTags.find(isFavoriteCategory);
          }
          this.allTags = this.allTags.sort(
            (a: TrainingCategory, b: TrainingCategory) => {
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;
              return 0;
            }
          );
          await this.mountBranchOfficeList(token);
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
  name: 'training-top-colum',
  data: (): Data => ({
    trainings: [] as Colum[],
    expired: [] as Colum[],
    notDeadline: [] as Colum[],
    doing: [] as Colum[],
    done: [] as Colum[],
    conf: TopColum('expired'),
    check: false,
    allTags: [] as TrainingCategory[],
    filterTag: TrainingCategoryDefault,
    favoriteTag: emptyFavoriteCategory,
    existsFavoriteCategory: existsFavoriteCategory,
    branchOfficeList: [] as BranchOffice[],
    allBranchOfficeCheck: false,
    isLoading: false,
    snackbar: false,
    snackbarMessage: '',
    snackbarColor: '',
    snackbarTimeout: 3000,
  }),
  methods: {
    jump: function (id: string) {
      console.log('jump :', id);
      this.$router.push(`/detail/${id}?year=${this.year}&main=${this.main}`);
    },
    indexFormat: (src: number): string => {
      return EventService.getSafetyEducationIndexFormat(src);
    },
    toggleFavorite: async function (c: Colum) {
      const toggle = (c: Colum) => {
        const isCurrentFavorite = existsFavoriteCategory(c.tags);
        if (isCurrentFavorite) {
          c.tags = c.tags.filter(tag => !isFavoriteCategory(tag)); // tags から除外
        } else {
          c.tags = [...c.tags, this.favoriteTag]; // tags に追加
        }
      };
      toggle(c);
      const token = await this.user?.getIdToken();
      let fIDs = this.trainings
        .filter((c: Colum) => existsFavoriteCategory(c.tags))
        .map((c: Colum) => c.id);
      const param = {
        favoriteIDs: fIDs,
      };
      try {
        await EventService.updateFavoriteTrainingIDs(token, param);
        this.initBranchOfficeList();
      } catch (err) {
        // DB更新失敗したので元に戻す
        toggle(c);
        console.log(err);
        this.snackbarMessage = `${this.favoriteTag.name}の更新に失敗しました`;
        this.snackbarColor = 'error';
        this.snackbarTimeout = 3000;
        this.snackbar = true;
      }

      const existsFavoriteIDs = fIDs.length >= 1;
      if (existsFavoriteIDs) {
        if (!existsFavoriteCategory(this.allTags)) {
          this.allTags = [...this.allTags, this.favoriteTag]; // カテゴリー に追加
        }
      } else {
        this.allTags = this.allTags.filter(
          (tag: TrainingCategory) => !isFavoriteCategory(tag) // カテゴリー から除外
        );
      }
      this.allTags.sort((a: TrainingCategory, b: TrainingCategory) => {
        if (a.order < b.order) return -1;
        if (a.order > b.order) return 1;
        return 0;
      });
    },
    async mountBranchOfficeList(token: string) {
      if (this.sameGroupBranchOfficeList.length === 0) {
        return;
      }
      const {data: fData} = await EventService.listGroupFavorite(token);
      const favoriteIDsCSVMap = new Map(
        fData.favoriteCategories.map((f: FavoriteCategory) => [
          f.branchOfficeID,
          f.trainingIDs.sort(trainingIDsCompare).join(','),
        ])
      );
      this.branchOfficeList = this.sameGroupBranchOfficeList.map(
        (bo: GroupRes) =>
          ({
            ...bo,
            name: bo?.companyJName ?? bo?.companyName,
            check: false,
            favoriteIDsCSV: favoriteIDsCSVMap.get(bo.companyID) ?? '',
            msg: '',
          } as BranchOffice)
      ) as BranchOffice[];
      this.initBranchOfficeList();
    },
    initBranchOfficeList() {
      this.branchOfficeList.forEach((bo: BranchOffice) => {
        // 同じ設定済みの場合は check は on にしておく (disabled は <template> 側で制御)
        bo.check = this.isBranchOfficeSameFavoriteIDs(bo);
        bo.msg = this.createBranchOfficeMsg(bo);
      });
    },
    toggleBranchOffice(bo: BranchOffice) {
      if (this.isBranchOfficeSameFavoriteIDs(bo)) {
        return;
      }
      bo.check = !bo.check;
    },
    async copyFavorite() {
      const checkedBOList = this.branchOfficeList.filter((bo: BranchOffice) => {
        return bo.check && !this.isBranchOfficeSameFavoriteIDs(bo);
      });
      const checkedBOIds = checkedBOList.map((bo: BranchOffice) => {
        return bo.companyID;
      });
      try {
        this.isLoading = true;
        const token = await this.user?.getIdToken();
        let fIDs = this.trainings
          .filter((c: Colum) => existsFavoriteCategory(c.tags))
          .map((c: Colum) => c.id);
        await EventService.copyFavorite(token, {
          favoriteIDs: fIDs,
          // NOTE(ohtsuchi): 制限事項: 画面表示中 に 別のユーザー が 各営業所(コピー元,コピー先)の設定を更新した場合は その値を無視して 現在表示中の値で上書きする
          // NOTE(ohtsuchi): よって コピー元営業所 も 現在表示中の設定で 更新対象とする
          // NOTE(ohtsuchi): 楽観的ロックでエラー表示も検討したが ユーザーへの伝え方が難しい && そもそも発生する可能性がとても低い事象 なので シンプルに後勝ちの処理とする
          // NOTE(ohtsuchi): ユーザーから問い合わせが合った場合は サーバー側のログ と DB(operationHistories) を調査して返答する
          updateBranchOfficeIDs: [this.current, ...checkedBOIds],
        });
        checkedBOList.forEach((bo: BranchOffice) => {
          bo.favoriteIDsCSV = this.favoriteIDsCSV;
          bo.msg = this.createBranchOfficeMsg(bo);
        });
        this.snackbarMessage = 'コピーが成功しました';
        this.snackbarColor = 'success';
        this.snackbar = true;
      } catch (err) {
        console.log(err);
        this.snackbarMessage = 'コピーが失敗しました';
        this.snackbarColor = 'error';
        this.snackbar = true;
      } finally {
        this.isLoading = false;
      }
    },
    isBranchOfficeSameFavoriteIDs(bo: BranchOffice): boolean {
      return bo.favoriteIDsCSV === this.favoriteIDsCSV;
    },
    createBranchOfficeMsg(bo: BranchOffice): string {
      return this.isBranchOfficeSameFavoriteIDs(bo)
        ? '(同じ設定です)'
        : bo.favoriteIDsCSV !== ''
        ? `(注意:上書きになります)(現在の設定=${bo.favoriteIDsCSV})`
        : '';
    },
  },
  computed: {
    columGroups(): ColumGroups {
      const trainingsByStatus = [
        this.expired,
        this.notDeadline,
        this.doing,
        this.done,
      ];
      if (this.filterTag === TrainingCategoryDefault) {
        return trainingsByStatus;
      }

      return trainingsByStatus.map((trainings: Colum[]) => {
        return trainings.filter(t => {
          return t.tags.some(tag => tag.key === this.filterTag);
        });
      });
    },
    canShowFilterTag(): boolean {
      return !this.main;
    },
    favoriteIDsCSV(): string {
      // お気に入り登録されているトレーニングIDをIDの昇順で並び替えてから結合したCSV文字列を返す
      return this.trainings
        .filter((c: Colum) => existsFavoriteCategory(c.tags))
        .map((c: Colum) => c.id)
        .sort(trainingIDsCompare)
        .join(',');
    },
    isViewBranchOfficeList(): boolean {
      return (
        // 統括アカウントで同グループの他営業所が存在する
        this.branchOfficeList.length > 0 &&
        // カテゴリーで favorite が選択されている
        this.filterTag === FAVORITE_CATEGORY_KEY &&
        // カテゴリーで favorite が選択されている状態で
        // 全ての favorite のトレーニングを除外して 0件になった場合は 以下の条件は false になる
        this.allTags.some((tag: TrainingCategory) => isFavoriteCategory(tag))
      );
    },
    isAnyBranchOfficeChecked() {
      const ret = this.branchOfficeList.some((bo: BranchOffice) => {
        return bo.check && !this.isBranchOfficeSameFavoriteIDs(bo);
      });
      return ret;
    },
    isAllBranchOfficeSameFavoriteIDs(): boolean {
      return this.branchOfficeList.every((bo: BranchOffice) =>
        this.isBranchOfficeSameFavoriteIDs(bo)
      );
    },
    isNoSubGroup: function (): boolean {
      return (
        this.noSubGroupStartYear != 0 &&
        Number(this.year) >= this.noSubGroupStartYear
      );
    },
    ...mapState([
      'user',
      'current',
      'currentScope',
      'sameGroupBranchOfficeList',
      'noSubGroupStartYear',
      'sortBy', // TODO (ohtsuchi) 2025年以降 コードを削除
    ]),
  },
  watch: {
    allBranchOfficeCheck(val) {
      this.branchOfficeList.forEach((bo: BranchOffice) => {
        if (this.isBranchOfficeSameFavoriteIDs(bo)) {
          return;
        }
        bo.check = val;
      });
    },
  },
});
